export default {
	// common locales
	"xero.close": "Close",
	"xero.cancel": "Cancel",
	"xero.ok": "Ok",
	"xero.back": "Back",
	"xero.view": "View",
	"xero.status": "Status",
	"xero.status-message": "Status Message",
	"xero.cancelled": "Cancel",
	"xero.brand-name": "uPOS Brand Name",
	"xero.outlet-name": "uPOS Outlet Code",
	"xero.terminal-name": "uPOS Terminal",
	"xero.payment-type": "uPOS Payment Type",
	"xero.edit": "Edit",
	"xero.filter": "Filter Invoice",
	"xero.config": "Invoice Config",
	"xero.connect": "Connect to Xero",
	"xero.addNew": "New Mapping",
	"xero.addConfig": "New Configuration",
	"xero.addNewConfig": "New Invoice Config",
	"xero.editNew": "Edit Mapping",
	"xero.editConfig":"Edit Invoice Configuration",
	"xero.uposType": "uPOS Type",
	"xero.amount-type": "Amount Type",
	"xero.filter": " Filter",
	"xero.acc-date": "Accounting Date",
	"xero.total-selected": "Total Selected",
	"xero.confirm-post": "Repost",
	"xero.invoice-number": "Invoice No.",
	"xero.invoice-type": "Invoice Type",
	"xero.reference-number": "Reference No.",
	"xero.tracking-category-1": "Tracking Category",
	"xero.tracking-category-1-option": "Tracking Option",
	"xero.tracking-category-2": "Tracking Category 2 - Company",
	"xero.line-amount": "Amount",
	"xero.line-amount-type": "Line Amount Type",
	"xero.line-amount-type.inclusive": "Line items are inclusive tax",
	"xero.line-amount-type.exclusive": "Line items are exclusive tax",
	"xero.line-amount-type.no-tax": "Line items have no tax",
	"xero.line-details-type": "Details Type",
	"xero.line-details-type.placeholder": "Each line item is a...",
	"xero.document-type": "Acc. Doc Type",
	"xero.organisation": "Acc. Org.",
	"xero.tax": "Tax Code / Tax Rate",
	"xero.account": "Payment Method / Account",
	"xero.contact": "Debtor / Contact",
	"xero.confirm-title": "Confirm Repost ",
	"xero.confirm-title2": " Invoices",
	"xero.confirm-subtitle": "Are you sure you want to repost the following Invoices",
	"xero.item": "Item Code",
	"xero.description": "Description",
	"xero.enable": "Enable",
	"xero.enabled": "Active",
	"xero.enabled-from": "Active From",
	"xero.disable": "Disable",
	"xero.disabled": "Disabled",
	"xero.line-items": "Line Items",
	"xero.created-at": "Created At",
	"xero.duplicate": "Duplicate",
	"xero.remove": "Remove",

	// page titles
	"xero.mapping.page-description": "Link AutoCount / Xero codes to Upos objects for posting invoices to AutoCount / Xero.",
	"xero.config.page-description": "Configure AutoCount / Xero Invoice generation templates.",
	"xero.invoice.page-description": "Invoices that have been created for posting to AutoCount / Xero.",
	"xero.invoice-working.page-description": "Invoices that are currently in-queue to be processed by AutoCount / Xero.",
	"xero.invoice-unposted.page-description": "Invoices that failed to post to AutoCount / Xero and require your attention.",

	// placeholders / tooltips
	"xero.filterType": "Select Upos Type",
	"xero.invoiceType": "Select Invoice Type",
	"xero.amountType": "Select Amount Type",
	"xero.detailType": "Select Detail Type",
	"xero.addTimeframe": "Select Time Frame",
	"xero.brand-name.placeholder": "Select uPOS Brand",
	"xero.outlet-name.placeholder": "Select uPOS Outlet",
	"xero.terminal-name.placeholder": "Select uPOS Terminal",
	"xero.amount-type.placeholder": "Select amount type",
	"xero.payment-type.placeholder": "Select uPOS payment type",
	"xero.selectAccCode": "Select Accounting Code",
	"xero.selectItemCode": "Select Item Code",
	"xero.selectXeroCode": "Select Xero Code",
	"xero.selectXeroTax": "Select Tax Code / Tax Rate",
	"xero.selectXeroAccount": "Select Payment Method / Account",
	"xero.selectXeroDocumentType": "Select Accounting Document Type",
	"xero.selectXeroOrg": "Select Accounting Organisation",
	"xero.selectXeroCompany": "Select Company",
	"xero.search": "Search ID",
	"xero.MapSearch": "Search Name and Code",
	"xero.searchInvoice": "Search Invoice No.",
	"xero.filter.status": "Search or select status",
	"xero.selectXeroContact": "Select Debtor / Contact",
	"xero.invoice-type.tooltip": "Each invoice is a...",
	"xero.tracking-category-1.placeholder": "Select a tracking category",
	"xero.tracking-category-1-option.placeholder": "Select a tracking option",
	"xero.line-amount-type.placeholder": "Select line item type",
	"xero.item.tooltip": "Default item code is...",
	"xero.config.search": "Search Tracking Option",

	// validation messages
	"xero.invoice-type.required": "Each invoice is for...?",
	"xero.amount-type.required": "Which value to be used?",
	"xero.line-amount-type.required": "Is there tax for each line item?",
	"xero.line-details-type.required": "Each line item is a...?",
	"xero.brand-name.required": "Select a uPOS brand",
	"xero.outlet-name.required": "Select a uPOS outlet",
	"xero.terminal-name.required": "Select a uPOS terminal",
	"xero.organisation.required": "Select an Accounting Organisation for this invoice",
	"xero.contact.required": "Select a Debtor / Contact for this invoice",
	"xero.account.required": "Select a Paymenth Method / Account for this invoice",
	"xero.item.required": "Select a default Item Code for this invoice",
	"xero.tax.required": "Select a Tax Code / Tax Rate for this invoice",
	"xero.document-type.required": "Select a Accounting Document Type for this config",
	"xero.enabled-from.required": "Select the active start date for this config",

	// xero invoice locales
	"xero.invoice.ref-number": "Invoice Ref. #",
	"xero.invoice.contact": "To",
	"xero.invoice.item-code": "Item Code",
	"xero.invoice.acc-date": "Invoice Date",
	"xero.invoice.details": "Details",
	"xero.invoice.line-items": "Line Items",
	"xero.invoice.repost-or-cancel": "Repost / Cancel Invoice",
	"xero.invoice.repost": "Repost Invoice",
	"xero.invoice.repost-single-title": "Confirm repost Invoice Reference No.",
	"xero.invoice.repost-title": "Confirm Repost of Invoices",
	"xero.invoice.repost-description": "Are you sure you want to repost this Invoice?",
	"xero.invoice.cancel-title": "Cancel Invoice Reference No.",
	"xero.invoice.cancel-description": "This is an irreversible action. Are you sure you want to cancel posting of this Invoice?",
	"xero.invoice.cancel": "Cancel Posting",
	"xero.invoice.upos-brand": "uPOS Brand",
	"xero.invoice.upos-outlet": "uPOS Outlet",
	"xero.invoice.upos-terminal": "uPOS Terminal",
	"xero.invoice.tax-type": "Tax Type",
	"xero.invoice.total-amount": "Total Amount",
	"xero.invoice.posted-by": "Posted By",
	"xero.invoice.posted-date": "Posted Date",
	"xero.invoice.cancelled-by": "Cancelled By",
	"xero.invoice.cancelled-date": "Cancelled Date",

	// amount types
	"xero.amount-type.revenue": "REVENUE",
	"xero.amount-type.collected": "COLLECTED",
	"xero.amount-type.greater-than": "COLLECTED ≥ REVENUE",

	// autocount locales
	"xero.autocount-connect": "Connect to AutoCount",
	"xero.autocount-connect-title": "Connect to uPOS AutoCount Bridge API",
	"xero.autocount.url": "API Url",
	"xero.autocount.url-required-message": "Enter the url of upos autocount bridge api",
	"xero.autocount.secret": "API Secret",
	"xero.autocount.secret-required-message": "Enter the shared secret between upos autocount bridge api and upos",

	// enabling / disabling locales
	"xero.disable.prompt": "Are you sure you want to disable Invoice Configuration for ",
	"xero.enable.prompt": "Are you sure you want to enable Invoice Configuration for ",
	"xero.re-enable.prompt1": "Last known invoice for ",
	"xero.re-enable.prompt2": "was created on ",
	"xero.re-enable.prompt3": "When do you want to start posting from?",
	"xero.config.uneditable.title": "This configuration cannot be edited",
	"xero.config.uneditable.subtitle": "There are existing accounting invoices associated with this configuration. Please disable and create a new configuration if required.",
	"xero.delete.prompt": "Are you sure you want to delete Invoice Configuration ID ",
};